import React from 'react';
import styles from './page-not-found.scss';

const PageNotFound = () => (
	<div className={styles.wrapper}>
		<div className={styles.title}>
			Sorry, that page does not exist!
		</div>
		<div className={styles.content}>
			Please click 
			<a 
				className={styles.redirect_link}
				href='/orders'
			>
				{' here '} 
			</a>
			to return to home page.
		</div>
	</div>
);

export default PageNotFound;
